import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    actionText: '',
    templateName: '',
    templateDescription: '',
    published: false,
    badgeTitle: '',
    badgeColor: '#ff6b35',
    badge: false,
    templateImage: null,
    templateIcon: null,
    templateBackground: null,
    templatePriority: 0,
    loading: false,
    error: null
};

const templateSlice = createSlice({
    name: "template",
    initialState,
    reducers: {
        setLoading(state, action) {
            state.loading = action.payload;
        },
        setError(state, action) {
            state.error = action.payload;
        },
        updateField(state, action) {
            const { field, value } = action.payload;
            state[field] = value;
        },
        loadTemplateData(state, action) {
            return { ...state, ...action.payload, loading: false, error: null };
        },
        resetTemplate(state) {
            return { ...initialState };
        }
    }
});

export const { setLoading, setError, updateField, loadTemplateData, resetTemplate } = templateSlice.actions;
export default templateSlice.reducer;